export function createDocumentWorkflowService(api) {
  const root = (companyId) => `/company/${companyId}/document-workflow`;
  const result = (request) => request.then((response) => response.data);
  return {
    list: (companyId, scope, path) =>
      result(api.get(root(companyId), { params: { scope, path } })),
    createRequest: (companyId, input) =>
      result(api.post(`${root(companyId)}/requests`, input)),
    requestInitial: (companyId, kinds) =>
      result(api.post(`${root(companyId)}/requests/initial`, { kinds })),
    deleteRequest: (companyId, requestId, scope) =>
      result(api.post(`${root(companyId)}/requests/${requestId}/delete`, {}, { params: { scope } })),
    deleteFile: (companyId, fileId, scope) =>
      result(api.post(`${root(companyId)}/files/${fileId}/delete`, {}, { params: { scope } })),
    closeRequest: (companyId, requestId, scope, input) =>
      result(
        api.post(`${root(companyId)}/requests/${requestId}/close`, input, {
          params: { scope },
        }),
      ),
    register: (companyId, scope, file) =>
      result(
        api.post(
          `${root(companyId)}/files/register`,
          { key: file.key },
          { params: { scope } },
        ),
      ),
    review: (companyId, fileId, scope, input) =>
      result(
        api.post(`${root(companyId)}/files/${fileId}/review`, input, {
          params: { scope },
        }),
      ),
    upload: (companyId, scope, input, file) => {
      const body = new FormData();
      Object.entries(input).forEach(([key, value]) => {
        if (value) body.append(key, value);
      });
      body.append("file", file);
      return result(
        api.post(`${root(companyId)}/files/upload`, body, {
          params: { scope },
        }),
      );
    },
    download: (companyId, scope, file) => {
      const prefix = /^COMPANIES\/[^/]+\/DOCUMENTS\//;
      if (!prefix.test(file.key))
        return Promise.reject(
          new Error("Documento non disponibile nell’archivio aziendale."),
        );
      return result(
        api.get(`/company/${companyId}/documents/download`, {
          params: { key: file.key.replace(prefix, "") },
        }),
      );
    },
  };
}
